module.exports = __webpack_public_path__ + "img/modalnouser.a16fa31c.svg";